module.exports = __webpack_public_path__ + "static/media/custom.cbba66a1.svg";